/** Product card sticker values — must match backend + Flutter SVG assets. */
export const PRODUCT_STICKER_WOW = 'wow';
export const PRODUCT_STICKER_BEST_SELLING = 'best_selling';
export const PRODUCT_STICKER_GREAT = 'great';

export const PRODUCT_STICKER_VALUES = [
  PRODUCT_STICKER_WOW,
  PRODUCT_STICKER_BEST_SELLING,
  PRODUCT_STICKER_GREAT,
];

export const PRODUCT_STICKER_OPTIONS = [
  { value: '', label: 'No sticker' },
  { value: PRODUCT_STICKER_WOW, label: 'WOW' },
  { value: PRODUCT_STICKER_BEST_SELLING, label: 'Best Selling' },
  { value: PRODUCT_STICKER_GREAT, label: 'Great' },
];
